import { AHAnimatedPageIndicator, Box, useLayoutContext } from "arkh";
import React, { PropsWithChildren } from "react";
import { View } from "react-native";
import { useDerivedValue } from "react-native-reanimated";

export function Pager(
  props: PropsWithChildren<{
    pages: React.ReactElement[];
    pageIndex: number;
    width: number;
  }>
) {
  const layout = useLayoutContext();

  const p = useDerivedValue(() => props.pageIndex);
  return (
    <>
      <View style={{ flex: 1, height: "100%" }}>
        {props.width > 1 ? (
          <Page width={props.width} focused>
            {props.pages[props.pageIndex]}
          </Page>
        ) : null}
      </View>
      <Box
        style={{
          position: "absolute",
          bottom: layout.space.medium,
          left: 0,
          right: 0,
        }}
      >
        <AHAnimatedPageIndicator
          page={p}
          direction="horizontal"
          numberOfItems={props.pages.length}
        />
      </Box>
    </>
  );
}
function Page(props: {
  children: React.ReactNode;
  width: number;
  focused: boolean;
}) {
  return (
    <Box style={{ width: props.width, flex: 1 }}>
      {props.focused ? props.children : null}
    </Box>
  );
}
